import { object, string } from 'yup';

const requestResetValidation = object().shape({
  username: string().required('Username Required')
});

const requestResetDefaults = { username: '' };

const resetValidation = object().shape({
  password: string().required('New password is required'),
  confirmPassword: string().required('Please confirm password')
});

const resetDefaults = { password: '', confirmPassword: '' };

export { requestResetValidation, requestResetDefaults, resetValidation, resetDefaults };
